import React from 'react';
import Footer from '../components/Footer';

const Contact = () => {
  return (
    <>
      <section className="container my-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Contact Us</h2>
          <p className="text-muted">
            Fill out the form below to book your dental appointment
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card facility-card p-4">
              <div className="card-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label fw-bold">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter your name"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="contact" className="form-label fw-bold">
                      Contact Number
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="contact"
                      placeholder="Enter your contact number"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="address" className="form-label fw-bold">
                      Address
                    </label>
                    <textarea
                      className="form-control"
                      id="address"
                      rows="3"
                      placeholder="Enter your address"
                      required
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="date" className="form-label fw-bold">
                      Appointment Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="date"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label fw-bold">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="4"
                      placeholder="Provide details of your dental issue or inquiry"
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .facility-card {
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }
        .facility-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          transition: 0.3s ease-in-out;
        }
        .btn-primary {
          background-color: #007bff;
          border-color: #007bff;
        }
        .btn-primary:hover {
          background-color: #0056b3;
          border-color: #0056b3;
        }
      `}</style>

      <Footer />
    </>
  );
};

export default Contact;